import React from 'react';
import { useForm } from 'react-hook-form';
import { withRouter } from 'react-router-dom';
import { useStateMachine } from 'little-state-machine';
import { compose } from 'redux';
import { connect } from 'react-redux';
import updateAction from './updateAction';
import Loader from '../../utils/Loader';
import { addOnboardDetails } from '../../redux/profile/profile.actions';
import Card from 'react-bootstrap/Card';

const Step4 = ({ history, phone, email, addOnboardDetails }) => {
	const { register, handleSubmit, watch, errors } = useForm();
	const revealSubscription = watch('isSubscribe');
	const { state, action } = useStateMachine(updateAction);

	const onSubmit = async (data) => {
		if (!data.email) {
			data['email'] = email;
		}
		if (!data.phone) {
			data['phone'] = phone;
		}
		action(data);

		history.push('./step5');
	};

	Loader.hide();
	return (
		<Card>
			<Card.Header className="setup-content" id="step-4">
				<h3>Do you wish to receive updates and offers?</h3>
			</Card.Header>
			<Card.Body>
				<form onSubmit={handleSubmit(onSubmit)}>
					<p>
						Would you like to receive updates (and offers) on our English courses on
						Email and SMS?
					</p>
					<div className="funkyradio">
						<span className="profileError">
							{errors.isSubscribe?.type === 'required' && 'Notification is required'}
						</span>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								id="radio1tt"
								ref={register({
									required: true,
								})}
								value={1}
								defaultChecked={state.data?.isSubscribe === '1'}
							/>
							<label for="radio1tt">Yes</label>
						</div>
						<div className="funkyradio-success">
							<input
								type="radio"
								name="isSubscribe"
								value={0}
								defaultChecked={state.data?.isSubscribe === '0'}
								ref={register({
									required: true,
								})}
								id="radio2tt"
							/>
							<label for="radio2tt">No</label>
						</div>
					</div>

					{(revealSubscription === '1' ||
						(typeof revealSubscription === 'undefined' &&
							state.data?.isSubscribe === '1')) &&
					!phone ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="phone">
								Phone
							</label>
							<small style={{ paddingLeft: '5px' }}>(optional)</small>
							<input
								type="text"
								className="form-control"
								name="phone"
								ref={register({
									pattern: /^[6789]\d{9}$/,
								})}
								defaultValue={state.data?.phone || state.data?.whatsappNumber}
							/>
							<span className="profileError">
								{errors.phone?.type === 'pattern' && 'Incorrect mobile number'}
							</span>
						</div>
					) : null}

					{(revealSubscription === '1' ||
						(typeof revealSubscription === 'undefined' &&
							state.data?.isSubscribe === '1')) &&
					!email ? (
						<div className="form-group" style={{ marginTop: '10px' }}>
							<label className="control-label" htmlFor="email">
								E-mail
							</label>
							<small style={{ paddingLeft: '5px' }}>(optional)</small>
							<input
								type="text"
								className="form-control"
								name="email"
								ref={register({
									pattern: /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/,
								})}
								defaultValue={state.data?.email}
							/>

							<span className="profileError">
								{errors.email?.type === 'pattern' && 'Incorrect email id'}
							</span>
						</div>
					) : null}

					<button
						aria-label="next"
						className="btn btn-primary nextBtn pull-right"
						type="submit"
					>
						Next
					</button>
				</form>
			</Card.Body>
		</Card>
	);
};

const mapStateToProps = (state) => {
	const { phone, email } = state.rootReducer.userDetails;
	return {
		phone,
		email,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		addOnboardDetails: (obj) => dispatch(addOnboardDetails(obj)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(Step4);
